import script from "./EcologicalPartnerComp.vue?vue&type=script&setup=true&lang=js"
export * from "./EcologicalPartnerComp.vue?vue&type=script&setup=true&lang=js"

import "./EcologicalPartnerComp.vue?vue&type=style&index=0&id=ea6b750a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea6b750a"]])

export default __exports__